import { action } from 'mobx';
import parseDate from '../shared/parseDate';
import ModelBase from './ModelBase';

export default class Discount extends ModelBase {
  static className = 'Discount';

  @action
  static fromJSON(id, json) {
    json.begDate = parseDate(json.begDate);
    json.endDate = parseDate(json.endDate);
    
    const result = super.fromJSON(id, json);

    return result;
  }
}




// WEBPACK FOOTER //
// ./src/store/Discount.js